export const isDateInFuture = (date: Date): boolean => {
  return date.getTime() > Date.now()
}
